import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import CommerceItemHeader
  from 'components/dashboard/commerce-content/commerce-link/CommerceItemHeader';
import CommerceItemForm
  from 'components/dashboard/commerce-content/commerce-link/CommerceItemForm';

import './CommerceLinkItem.css';

function CommerceLinkItem(props) {
  const {
    item,
    isDragging,
    setExpandedLinkId,
    expandedLinkId,
  } = props;

  const [openForm, setOpenForm] = useState(false);

  useEffect(() => {
    if (isDragging) {
      setOpenForm(false);
    }
  }, [isDragging]);

  useEffect(() => {
    if (expandedLinkId !== item.id) {
      setOpenForm(false);
    }
  }, [expandedLinkId]);

  return (
    <div className="commerce-link-item__component">
      <div className="link-wrapper">
        <div className="header-container">
          <CommerceItemHeader
            key={`commerce-item-header-${item.id}`}
            item={item}
            openForm={openForm}
            setOpenForm={setOpenForm}
            setExpandedLinkId={setExpandedLinkId}
          />
        </div>
        {!isDragging && openForm &&
          <div className="form-container">
            <CommerceItemForm
              key={`commerce-item-form-${item.id}`}
              item={item}
            />
          </div>
        }
        <div
          className="arrow-block"
          onClick={() => {
            setOpenForm(!openForm);
            if (!openForm) {
              setExpandedLinkId(item.id);
            }
          }}
          role="button"
          tabIndex={-1}
        >
          <div className={`arrow-icon${openForm ? ' up' : ''}`} />
        </div>
      </div>
    </div>
  );
}

CommerceLinkItem.propTypes = {
  setExpandedLinkId: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  isDragging: PropTypes.bool.isRequired,
  expandedLinkId: PropTypes.number,
};

CommerceLinkItem.defaultProps = {
  expandedLinkId: PropTypes.null,
};

export default CommerceLinkItem;
